import React from 'react';

interface BioTextProps {
  text: string | null | undefined;
}

/**
 * Component for rendering bio text with proper line break handling
 * - Double newlines create separate paragraphs
 * - Single newlines within paragraphs become <br> tags
 */
const BioText: React.FC<BioTextProps> = ({ text }) => {
  if (!text) return null;

  const paragraphs = text
    .split(/\n\s*\n/) // Split on double newlines (paragraph breaks)
    .map((paragraph) => paragraph.trim())
    .filter((paragraph) => paragraph.length > 0);

  return (
    <>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>
          {paragraph.split('\n').map((line, lineIndex, lines) => (
            <React.Fragment key={lineIndex}>
              {line}
              {lineIndex < lines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      ))}
    </>
  );
};

export default BioText;
